import { useEffect } from 'react'

export default function SwaggerRedirect() {
  useEffect(() => {
    // Redirect to Swagger UI
    window.location.href = '/swagger/'
  }, [])

  return (
    <div className="section-container py-20 text-center">
      <p className="text-gray-600">Redirecting to API documentation...</p>
    </div>
  )
}
